import bgBottom from './image/bg-bottom.png';
import buttonApple from './image/app-store.png';
import buttonGoogle from './image/ggplay-black.png';
import googlePlay from './image/googleplay.png';
import applePlay from './image/apple.png';
import buy from './image/buy.png';
import bgTop from './image/bg-top.png';
import tele from './image/tele.png';
import devtool from './image/devtool.png';
import x from './image/x.png';

import React, { useEffect } from 'react';
import './App.css';
import analyticsController from './AnalyticsController';

const App = () => {
  useEffect(() => {
    analyticsController.trackPageView();
  }, []);

  const trackClick = (name, url) => {
    analyticsController.trackEvent(name, {
      url,
    });
  };
  
  const handleButtonDevtool = () => {
    trackClick('click_devtool', window.location.href);
    alert('Button handleButtonDevtool');
  };
  const handleButtonTele = () => {
    trackClick('click_tele', window.location.href);
    alert('Button handleButtonTele');
  };
  const handleButtonX = () => {
    trackClick('click_x', window.location.href);
    alert('Button handleButtonX');
  };
  const handleButtonGG = () => {
    const url = 'https://play.google.com/store/apps/details?id=make.market.making.crypto.ai.meme.coin.bitcoin';
    trackClick('click_google_play', url);
    window.open(url, '_blank');

  };

  const handleButtonApple = () => {
    const url = 'https://apps.apple.com/us/app/make-market-making/id6738039114';
    trackClick('click_app_store', url);
    window.open(url, '_blank');
  };

  const handleBuy = () => {
    const url = 'https://apps.apple.com/us/app/make-market-making/id6738039114';
    trackClick('click_buy', url);
    window.open(url, '_blank');
  };

  return (
	      <div className="container">
	        {/* Image bacground */}
	        <div className="image-container">
	          {/* buy buttons */}
	          <div className="social-container">
	            <button onClick={handleButtonDevtool} className="image-button-store">
	              <img src={devtool} alt="Devtool" />
	            </button>
	            <button onClick={handleButtonTele} className="image-button-store">
	              <img src={tele} alt="Telegram" />
	            </button>
	            <button onClick={handleButtonX} className="image-button-store">
	              <img src={x} alt="X" />
	            </button>
	            <button onClick={handleBuy} className="image-button-store">
	              <img src={buy} alt="Buy" />
	            </button>
	          </div>

	          <img src={bgTop} alt="" aria-hidden="true" className="top-image" />
	          <img src={bgBottom} alt="" aria-hidden="true" className="top-image" />
	          <div className="image-logo-container">
	            <p className="overlay-text">DOWNLOAD NOW</p>
	            <button onClick={handleButtonGG} className="image-button">
	              <img src={buttonGoogle} alt="Google Play Button"/>
	            </button>
            <button onClick={handleButtonApple} className="image-button">
              <img src={buttonApple} alt="App Store Button"/>
            </button>
          </div>

          {/* Store buttons */}
          <div className="store-container">
            <button onClick={handleButtonGG} className="image-button-store">
              <img src={googlePlay} alt="Google Play Button"/>
            </button>
            <button onClick={handleButtonApple} className="image-button-store">
              <img src={applePlay} alt="App Store Button"/>
            </button>
          </div>
        </div>
      </div>
  );
};

export default App;
